import React  from "react";
import { TextSnippet } from "@mui/icons-material";
import { LinkedIn } from "@mui/icons-material";
import { Instagram } from "@mui/icons-material";
import { GitHub } from "@mui/icons-material";

export const Sidebardata = [
    {
        title:"",
        icon:<LinkedIn />,
        link: "https://www.linkedin.com/in/kmartin729/",
        class: "sidebar-Item-Top"
    },
    {
        title:"",
        icon:<GitHub />,
        link: "https://github.com/kevin729",
        class: "sidebar-Item-Bottom"
    }
]